import type { SobreimpresoTextbox } from './types';
import { resizeSobreimpresoHeight } from './render';

const ATTACHED_KEY = '__sobreimpresoListenerAttached';

type Marked = SobreimpresoTextbox & { [ATTACHED_KEY]?: boolean };

const CONTROLS_VISIBILITY = {
  tl: false,
  tr: false,
  bl: false,
  br: false,
  mt: false,
  mb: false,
  ml: true,
  mr: true,
  mtr: true
};

export function initSobreimpreso(s: SobreimpresoTextbox): void {
  const marked = s as Marked;
  if (marked[ATTACHED_KEY]) return;
  marked[ATTACHED_KEY] = true;

  s.setControlsVisibility(CONTROLS_VISIBILITY);
  if (s.sobreimpreso.minHeight == null) s.sobreimpreso.minHeight = 0;
  resizeSobreimpresoHeight(s);

  s.on('changed', () => resizeSobreimpresoHeight(s));
  s.on('modified', () => resizeSobreimpresoHeight(s));
}
